import { mapEnumToOptions } from '@abp/ng.core';

export enum JourneyStatus {
  Dispatch = 0,
  Arrived = 1,
  Completed = 2,
  OnRoute = 3,
  Canceled = 4,
}

export const journeyStatusOptions = mapEnumToOptions(JourneyStatus);
